import {ButtonType} from "../constants/ButtonType"
import {ProtocolComponent} from "../protocol-configuration/dto/ProtocolComponent";

export class OpenDialogDTO{
	protocolStepName: string;
	protocolStepIndex: number;
	buttonType: ButtonType;
	actionName: string;
	actionIndex: number;
	actionType: string;
	buttonClass: string;
	scans: Array<any> = [];
	end!: ProtocolComponent;
	plateScanValue!: Array<Array<string>>;
	plateSourcePlateIDValues!: Array<string>;
	stepListName: string;
	stepMapName: string;
	qcFail = false;
    requiredActions:string[];
    analysisBatchID:string =  null;
}
